var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.50425L6.58824 5.23075V2.88735C6.58824 2.33609 6.9091 1.83525 7.40989 1.60483C7.78443 1.4325 8.21557 1.4325 8.59011 1.60483C9.0909 1.83525 9.41177 2.33609 9.41177 2.88735V5.23075L14 7.50425V9.77776L9.41177 8.15383V11.4017L11.5294 12.376V14H4.47059V12.376L6.58824 11.4017V8.15383L2 9.77776V7.50425Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.d59e556853243939f3132cd504d08dfd.svg";
export { ForwardRef as ReactComponent };